import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { BasicButton } from 'components';
import { useCallback, useEffect } from 'react';
import classes from './index.module.css';

interface IDialog {
  btnText: string,
  btnVariant?: string
  children: React.ReactNode;
  isOpened?: boolean;
  onClose?: () => void;
  title: string,
}

const Dialog = ({ btnText, btnVariant, children, isOpened, onClose, title }: IDialog) => {
  const [opened, { open, close }] = useDisclosure(isOpened);
  const titleId = 'dialog-title';

  const onCloseWrapper = useCallback(() => {
    if (onClose) {
      onClose();
    }
    close();
  }, [onClose]);

  useEffect(() => {
    if (isOpened) open();
    else close();
  }, [isOpened]);

  return (
    <>
      <Modal.Root opened={opened} size='lg' onClose={onCloseWrapper} className={classes.modal} centered>
        <Modal.Overlay />
        <Modal.Content
          aria-labelledby={title ? titleId : undefined}
          aria-label={!title ? title : undefined}
          className={classes.content}
        >
          {title && (
            <Modal.Header>
              <Modal.Title id={titleId} className={classes.title}>
                {title}
              </Modal.Title>
              <Modal.CloseButton />
            </Modal.Header>
          )}
          <Modal.Body pt={20}>
            {children}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
      <BasicButton variant={btnVariant} onClick={open}>{btnText}</BasicButton>
    </>
  )
}

export default Dialog;